import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface GlobalConfigFormPayload {
  retention_window_days: number;
  renewal_reminder_days: number;
  grace_period_days: number;
  default_currency_id: number;
  default_timezone_id: number;
  default_theme_colour?: string;
  notes?: string;
}

const get = () => http.get(API_ENDPOINTS.globalConfig);

const update = (payload: GlobalConfigFormPayload) => http.patch(API_ENDPOINTS.globalConfig, payload);

const GlobalConfigService = { get, update };

export default GlobalConfigService;
